<script setup lang="ts">
defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    max-width="520"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="text-h6"> Submitted for Review </v-card-title>
      <v-card-text>
        <p class="mb-3">
          Your event has been submitted and is now awaiting review by the Arvee
          team.
        </p>
        <p class="text-body-2 text-on-surface-variant mb-2">
          What happens next:
        </p>
        <ul class="text-body-2 ml-4">
          <li>Our team will review your event details and pricing</li>
          <li>You'll receive a notification when a decision is made</li>
          <li>Most reviews are completed within 1–2 business days</li>
          <li>If approved, you can start fundraising from the event page</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          variant="flat"
          @click="emit('update:modelValue', false)"
        >
          Got it
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
